/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import Regionalization from '../../../../src/services/regionalization';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imageGameshowTitle from './title_gameshow.png';
import imageGameshowBrainstorm from './title_gameshow-brainstorm.png';
import imageGameshowPlayers from './title_gameshow_players.png';

import apprenticesPairArmsFolded from '../../images/characters/apprenticesPairArmsFolded.png';
import apprenticePointingUp2 from '../../images/characters/apprenticePointingUp2.png';
import apprenticePointingUp3 from '../../images/characters/apprenticePointingUp3.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';
import apprenticeFistUp from '../../images/characters/apprenticeFistUp.png';
import apprenticeHandsHips2 from '../../images/characters/apprenticeHandsHips2.png';
import apprenticeCurious from '../../images/characters/apprenticeCurious.png';
import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import ianShrugLaugh from '../../images/characters/ian_shrug_laugh.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_garbage.md';
import markdownFileLevel2 from './level2_foodWaste.md';
import markdownFileLevel3 from './level3_foodScraps.md';
import markdownFileLevel4 from './level4_wasteFreeLunch.md';
import markdownFileLevel5 from './level5_buySmart.md';
import markdownFileLevel6 from './level6_greenCycle.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) },
  '5': { md: new MarkdownScript(markdownFileLevel5) },
  '6': { md: new MarkdownScript(markdownFileLevel6) }
};

export function preloadGameShow () {
  preloader([
    imageGameshowTitle,
    imageGameshowBrainstorm,
    imageGameshowPlayers,
    apprenticesPairArmsFolded,
    apprenticePointingUp2,
    apprenticesFlexArms,
    apprenticePointingUp3,
    apprenticeFistUp,
    apprenticeHandsHips2,
    apprenticeCurious,
    saraSurprised,
    ianShrugLaugh
  ]);
}

function intro (level, regionData) {
  const md = levels[level].md;
  return videoSlide({
    id: 'intro',
    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
  });
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  if (level === 5) {
    return headingSlide({
      id: 'sizzle-brainstorm',
      bgColor: '#742CBF',
      afterImage: imageGameshowBrainstorm,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
    });
  } else {
    return headingSlide({
      id: 'sizzle',
      bgColor: '#742CBF',
      afterImage: imageGameshowTitle,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
    });
  }
}

function scoring (level, regionData) {
  const md = levels[level].md;
  return balloonSlide({
    id: 'scoring',
    characterSide: 'right',
    characterImage: apprenticeHandsHips2,
    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
    bgColor: '#742CBF'
  });
}

function questionSlide ({
    level,
    questionNumber,
    numQuestions,
    md,
    questionCharacterImage,
    answerCharacterImage,
    regionData}) {
  const questionSection = `Question ${questionNumber}`;
  const defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
  const questionCharacter = !questionCharacterImage ? apprenticeCurious : questionCharacterImage;
  const answerCharacter = !answerCharacterImage ? apprenticePointingUp3 : answerCharacterImage;
  let answer;
  if (defaultRegion) {
    answer = md.getSubSectionAsHtml(questionSection, `Answer - ${defaultRegion}`, false, regionData);
  } else {
    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
  }
  const answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);

  return [

    // if level 5, don't show 4 players please, and show instructions for
    // Brainstorm Edition on Q1 only
    (level === 5 && questionNumber === 1)
    ? balloonSlide({
      id: 'brainstorm-rules',
      characterSide: 'right',
      characterImage: saraSurprised,
      notes: md.getSubSectionAsHtml('Brainstorm Edition', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Brainstorm Edition', 'Content', false, regionData),
      bgColor: '#742CBF'
    })
    : null,

    // for all other levels show:
    (level !== 5)
    ? headingSlide({
      id: `${questionNumber}-four-players`,
      afterImage: imageGameshowPlayers,
      bgColor: 'black',
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
    })
    : null,

    // additional slide for level 1, question 6
    (level === 1 && questionNumber === 4)
    ? balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: apprenticeCurious,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-multiple-choice`,
      html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        `<br />` +
        `<p style="font color: white">Multiple choice, see next slide</h4>`,
      bgColor: '#45B3EC'
    })
    : null,

    balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: questionCharacter,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-question`,
      html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        `<br />` +
        `<p style="font color: white">Preview of next slide/answer</h4>` +
        answer
    }),

    balloonSlide({
      balloonType: `answer`,
      characterSide: `right`,
      characterImage: answerCharacter,
      questionNumber,
      id: `${questionNumber}-answer`,
      html: answer,
      notes: `<h2>Answer ${questionNumber} of ${numQuestions}</h2>` +
         `<br />` +
         ( !answerNotes.match(/SKIP/) ?
           md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData)
           : ''
         )
    })
  ];
}

function endOfGameShow (level) {
  return balloonSlide({
    id: 'end',
    characterSide: 'left',
    characterImage: apprenticeFistUp,
    bgColor: '#742CBF',
    html: `<h3>Level ${level} Game Show Completed!</h3>`,
    notes: 'Game show completed.'
  });
}

function level1 (regionData) {
  const level = 1;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 6, md, regionData })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'left',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 6, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 6, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 6, md, regionData })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 6, md, regionData })}
      {questionSlide({ level, questionNumber: 6, numQuestions: 6, md, regionData })}

      {/* The Repair Song */}
      {videoSlide({
        id: 'repair-song',
        notes: md.getSubSectionAsHtml('The Repair Song Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('The Repair Song Video', 'YouTube', regionData)
      })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level2 (regionData) {
  const level = 2;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 5, md, regionData })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'left',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 5, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level3 (regionData) {
  const level = 3;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 5, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level4 (regionData) {
  const level = 4;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 6, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 7, numQuestions: 8, md, regionData })}
      {questionSlide({ level, questionNumber: 8, numQuestions: 8, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level5 (regionData) {
  const level = 5;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 4, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level6 (regionData) {
  const level = 6;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Product Life-Cycle */}
      {balloonSlide({
        id: 'product-lifecycle',
        characterSide: 'right',
        characterImage: apprenticesFlexArms,
        notes: md.getSubSectionAsHtml('Product LifeCycle', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Product LifeCycle', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 5, md, questionCharacterImage: ianShrugLaugh, answerCharacterImage: saraSurprised, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 5, md, regionData })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 5, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level, regionData)}

      {/* Now for some solutions! */}
      {balloonSlide({
        id: 'solutions',
        characterSide: 'right',
        characterImage: apprenticesPairArmsFolded,
        notes: md.getSubSectionAsHtml('Solutions', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Solutions', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

    </Section>
  );
}

function gameShowSection ({ level, regionData }) {
  switch (level) {
  case 1:
    return level1(regionData);
  case 2:
    return level2(regionData);
  case 3:
    return level3(regionData);
  case 4:
    return level4(regionData);
  case 5:
    return level5(regionData);
  case 6:
    return level6(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default gameShowSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/20_gameShow/gameShowSection.jsx